import now_options from './now_options'
import member_seating_status from './member_seating_status'
import site_config from './site_config'
import data_init from './data_init'
import files from './files'
import permissions from './permissions'

export default function () {
  return [
    site_config(),
    data_init(),
    permissions(),
    files(),
    now_options(),
    member_seating_status()
  ]
}
